@if ((videoUrl() | typeOfVideo); as videoInfo) {

    @switch (videoInfo.type) {
        @case ('youtube') {
            <app-youtube-player [videoId]="videoInfo.id" [muted]="muted()"></app-youtube-player>
        }
        @case ('vimeo') {
            <app-vimeo-player [videoId]="videoInfo.id" [muted]="muted()"></app-vimeo-player>
        }
        @default {
            <p>Video Player not supported</p>
        }
    }
}

